import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';

import { StyledColumn } from './styles';

// padding prop accepts string that matches with theme spacing variable (i.e. sm, md, lg)
export const Column = ({ children, forwardedRef, ...props }) => (
  <StyledColumn ref={forwardedRef} {...props}>
    {children}
  </StyledColumn>
);

export const ForwardedColumn = forwardRef((props, ref) => (
  <Column forwardedRef={ref} {...props} />
));

Column.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  forwardedRef: PropTypes.oneOfType([
    // Either a function
    PropTypes.func,
    // Or the instance of a DOM native element (see the note about SSR)
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]),
  onClick: PropTypes.func,
  padding: PropTypes.string,
  targetRef: PropTypes.oneOfType([
    // Either a function
    PropTypes.func,
    // Or the instance of a DOM native element (see the note about SSR)
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]),
};

Column.defaultProps = {
  children: null,
  className: '',
  forwardedRef: undefined,
  onClick: () => {},
  padding: '',
  targetRef: undefined,
};
